import * as React from 'react';
import type { Category } from 'rest/category';
import { FormattedMessage } from 'react-intl';
import BookIcon from '@atlaskit/icon/glyph/book';
import type { CardLinkAppearance } from 'view/common/group-box-select';
import { RaiseRequestLink } from 'view/common/raise-request-link';

import { CategoryItem } from './category-item';
import messages from './messages';
import { CategorySectionTitle, Root, CategoryItems, CategoryItemContainer } from './styled';
import { FireScreenEventOnMount } from 'util/analytics/fire-screen-event';
import { AnalyticsContext } from '@atlaskit/analytics-next';
import { token } from '@atlaskit/tokens';
import { colors } from '@atlaskit/theme';

export interface CategoryListProps {
    categories: Category[];
    portalId: number;
    portalLink: string;
    hidden: boolean;
    className?: string;
    cardLinkAppearance?: CardLinkAppearance;
    showRequestCreateButton?: boolean;
    isEmbeddedRoute?: boolean;
}

export default class CategoryList extends React.Component<CategoryListProps> {
    static defaultProps = {
        portalId: undefined,
        categories: [],
    };

    render() {
        const {
            portalId,
            categories,
            portalLink,
            hidden,
            cardLinkAppearance,
            className,
            showRequestCreateButton,
            isEmbeddedRoute,
        } = this.props;

        if (hidden || !portalId || categories.length === 0) {
            return null;
        }

        const analyticData = {
            attributes: {
                numberOfCategories: categories.length,
            },
        };

        return (
            <AnalyticsContext data={analyticData}>
                <Root className={className}>
                    <FireScreenEventOnMount />
                    <CategorySectionTitle>
                        <BookIcon label="" aria-hidden="true" primaryColor={token('color.icon', colors.N500)} />
                        <FormattedMessage {...messages.kbCategorySectionTitle} />
                    </CategorySectionTitle>

                    <CategoryItems>
                        {categories.map((category) => (
                            <CategoryItemContainer key={category.id}>
                                <CategoryItem
                                    portalId={portalId}
                                    category={category}
                                    isEmbeddedRoute={isEmbeddedRoute}
                                />
                            </CategoryItemContainer>
                        ))}
                    </CategoryItems>
                    {showRequestCreateButton && (
                        <RaiseRequestLink
                            appearance={cardLinkAppearance}
                            to={portalLink}
                            isEmbeddedRoute={isEmbeddedRoute}
                        />
                    )}
                </Root>
            </AnalyticsContext>
        );
    }
}
